import $ from 'jquery';

import PcHeaderAnimator from './components/PcHeaderAnimator';
import HeaderNavigation from './components/HeaderNavigation';
import SpHeaderMenu from './components/SpHeaderMenu';

import TopHeroSlider from './components/TopHeroSlider';

import AnshinItemAccordion from './components/AnshinItemAccordion';

$(document).ready(() => {
  new PcHeaderAnimator();
  new HeaderNavigation();
  new SpHeaderMenu();
  new TopHeroSlider();
  new AnshinItemAccordion();
});
